import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { releaseNotesLink } from './release-notes-links';

@Component({
  selector: 'app-release-notes-link',
  imports: [TranslateModule],
  templateUrl: './release-notes-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './release-notes-link.component.scss',
})
export class ReleaseNotesLinkComponent {
  readonly releaseNotesLink = releaseNotesLink;
}
